export const GROWTH_PRODUCT = {
  title: 'Google Ads & SEO',
  subtitle: 'Digital marketing workspace',
} as const;

export const GROWTH_ACCENT_BAR = '#16314F';

export const GROWTH_DASHBOARD_META = {
  eyebrow: 'Google Ads & SEO',
  titleLead: 'Marketing',
  titleAccent: 'dashboard',
  period: 'April 2026 · month-to-date',
  updated: 'updated 12 min ago',
} as const;
